<template lang="pug">
#drawer-menu-camadas-ativas
    ul.componente-camadas__lista-camadas
        .el-tree__empty-block(v-if='layersAtivos_.length === 0')
            span.el-tree__empty-text
                | {{ $t('mensagens.menuCamadas.nenhumaCamadaAtiva') }}
        draggable(v-else, v-model='layersAtivos_')
            li(v-for='(layer, index) in layersAtivos_')
                el-collapse.camada-comum(
                    v-if='!layer.subtitle'
                )
                    el-collapse-item(:title='layer.nome', :name='layer.codigo')
                        template(slot='title')
                            .item-container
                                .item-inside-order
                                    span(style='margin-right: 12px')
                                        i.mdi.mdi-drag-vertical(
                                            style='font-size: 20px; margin-right: 20px'
                                        )
                                        i.el-icon-collection-tag(
                                            :style='{ color: layer.colorIcon || "#cacaca", "background-color": layer.colorIcon || "#cacaca", "border-radius": "3px", "font-size": "20px" }'
                                        )
                                    span(v-if='menuMaior').componente-camadas__title {{ labelName($t(`mensagens.camadas.${layer.codigo}`)) }}
                                    span(v-else).componente-camadas__title {{ labelNameMenuMenor($t(`mensagens.camadas.${layer.codigo}`)) }}
                                i.el-dialog__close.el-icon.el-icon-close(
                                    style='font-size: 20px',
                                    @click='removerCamada(layer)'
                                )
                        div(v-if='menuMaior', class='componente-camadas__opacidade')
                            span {{ $t('mensagens.menuCamadas.opacidade') }} (%):
                            el-slider(
                                v-model='layer.opacidade',
                                @input='alterarOpacidade(layer)',
                                :disabled='!layer.ativo'
                            )
                        div(v-else, class='componente-camadas__opacidade__menor')
                            span {{ $t('mensagens.menuCamadas.opacidade') }} (%):
                            el-slider(
                                v-model='layer.opacidade',
                                @input='alterarOpacidade(layer)',
                                :disabled='!layer.ativo'
                            )

                el-collapse.camada-subtitle(
                    v-else
                )
                    el-collapse-item(:title='layer.nome')
                        template(slot='title')
                            .item-container
                                .item-inside-order
                                    span(style='margin-right: 12px')
                                        i.mdi.mdi-drag-vertical(
                                            style='font-size: 20px; margin-right: 20px'
                                        )
                                    span(v-if='menuMaior').componente-camadas__title {{ labelName($t(`mensagens.camadas.${layer.codigo}`)) }}
                                    span(v-else).componente-camadas__title {{ labelNameMenuMenor($t(`mensagens.camadas.${layer.codigo}`)) }}
                                i.el-dialog__close.el-icon.el-icon-close(
                                    style='font-size: 20px; cursor: pointer',
                                    @click='removerCamada(layer)'
                                )
                        p(
                            v-if='layer.subtitle !== undefined',
                            v-for='item in layer.subtitle'
                        )
                            span(style='font-size: 15px; margin-right: 5px')
                                i.el-icon-collection-tag(
                                    :style='{ color: item.colorIcon || "#cacaca", "background-color": item.colorIcon || "#cacaca", "border-radius": "3px" }'
                                )
                            span {{ item.name }}

                        div(v-if='menuMaior', class='componente-camadas__opacidade')
                            span {{ $t('mensagens.menuCamadas.opacidade') }} (%):
                            el-slider(
                                v-model='layer.opacidade',
                                @input='alterarOpacidade(layer)',
                                :disabled='!layer.ativo'
                            )
                        div(v-else, class='componente-camadas__opacidade__menor')
                            span {{ $t('mensagens.menuCamadas.opacidade') }} (%):
                            el-slider(
                                v-model='layer.opacidade',
                                @input='alterarOpacidade(layer)',
                                :disabled='!layer.ativo'
                            )
</template>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'DrawerMenuCamadasAtivas',
    components: {
        draggable
    },
    props: {
        mapa: {
            type: Object,
            required: true
        },
        showStatesLayers: {
            type: Boolean,
            required: false,
            default: true
        },
        layersAtivos: {
            type: Array,
            required: false,
            default: null
        },
        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            layersAtivos_: this.layersAtivos
        };
    },
    methods: {
        orderLayer(list) {
            let mapa = this.mapa;
            let tam = list.length - 1;

            for (let i = tam; i >= 0; i--) {
                Object.entries(this.mapa._layers).map(function (item) {
                    if (
                        item[1]['wmsParams'] !== undefined &&
                        list[i].layerName === item[1]['wmsParams']['layers']
                    ) {
                        mapa._layers[item[0]].bringToFront();
                    }
                });
            }
        },

        alterarOpacidade({ leafletLayer, opacidade }) {
            leafletLayer.setOpacity(opacidade / 100);
        },

        labelName(text) {
            return text.length <= 30 ? text : text.substring(0, 30) + '...';
        },
        labelNameMenuMenor(text) {
            return text.length <= 12 ? text : text.substring(0, 12) + '...';
        },
        removerCamada(camada) {
            const vm = this;

            setTimeout(() => {
                vm.$emit('removerCamada', camada);
            }, 5);
        }
    },
    watch: {
        layersAtivos_(list) {
            this.$emit('orderLayersCamadasAtivas', list);
        },
        layersAtivos: {
            handler(newValue) {
                this.layersAtivos_ = newValue;
            },
            immediate: false
        }
    }
};
</script>

<style lang="scss">
#drawer-menu-camadas-ativas {
    .leaflet-control-camadas {
        box-shadow: none !important;
        border: none !important;
    }

    .componente-camadas__botao-controle {
        cursor: pointer;

        i {
            font-size: 20px;
            line-height: 30px;
            position: relative;
        }

        span {
            position: relative;
            top: -6px;
        }
    }

    .componente-camadas__container {
        border: 2px solid rgba(0, 0, 0, 0.2);
        background-clip: padding-box;
        border-radius: 4px;
        margin-right: -2px !important;
    }

    .componente-camadas__container {
        &.expandido {
            position: static;
            display: flex;
            justify-content: flex-end;

            .componente-camadas__botao-controle {
                width: 32px !important;

                i {
                    color: #0a9a84;
                }
            }
        }
    }

    .componente-camadas__lista-camadas {
        list-style: none;
        padding-inline-start: 0px;
        margin: 0;
        padding: 0;

        li {
            margin-bottom: 10px !important;
            word-wrap: break-word !important;
            background-color: rgb(255 255 255) !important;
            background-clip: border-box !important;
            border: 1px solid #e9e9e9 !important;
            border-radius: 7px !important;
            padding: 5px !important;
        }

        .el-checkbox__label {
            font-size: 13px;
        }

        .el-collapse-item__header {
            position: relative;
            border-radius: 5px;
            height: 35px !important;
            padding: 5px 0px 5px 5px;
            font-size: 16px;
            font-weight: 400;
            line-height: 18px;

            .item-container {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;

                .item-inside-order {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    width: 100%;
                }

                .el-dialog__close {
                    font-size: 18px !important;
                    margin-right: 5px;
                    color: #686868;
                    z-index: 30;
                }
            }
        }

        .el-collapse-item__arrow {
            position: absolute;
            left: 24px;
            top: 30%;
            font-size: 14px;
            font-weight: 600;
        }

        #el-collapse-content-6052 > div .camada-comm {
            .el-collapse-item {
                .el-collapse-item__content {
                    min-height: 60px;
                    max-height: 250px;
                }
            }
        }

        .el-collapse-item__wrap {
            border-bottom: none;
        }
        .el-collapse-item__content {
            padding-bottom: 5px;
        }
    }

    .el-switch.opcao-camada .el-switch__core {
        width: 30px !important;
    }

    .el-switch.is-checked .el-switch__core::after {
        margin-left: -11px !important;
    }

    .el-switch__core:after {
        width: 10px !important;
        height: 11px !important;
    }

    .el-switch__core {
        height: 15px !important;
    }

    .leaflet-control-camadas-base {
        margin-right: 12px !important;
    }

    .el-collapse-item__header .el-switch__core {
        width: 30px !important;
    }

    .leaflet-control-camadas-base .el-collapse-item__content {
        padding-bottom: 0px !important;
    }

    i.collapse-icon {
        height: 50px;
    }

    .el-switch {
        vertical-align: initial !important;
    }

    .componente-camadas__opacidade {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 16px;
        margin-left: 12px;
    }

    .componente-camadas__opacidade__menor {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 6px;
        margin-left: 12px;

        .el-slider {
            width: 40%;
            height: 20px;
        }
    }

    .componente-camadas__opacidade__biomas {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 16px;
        margin-left: 12px;

        .el-slider {
            width: 60% !important;
        }
    }

    .el-slider {
        width: 60%;
        height: 20px;
    }

    .el-slider__runway {
        margin-top: 5px !important;
        margin-bottom: 0px;
    }

    .componente-camadas__title {
        display: inline-block;
        font-size: 14px;
        font-weight: 500;
        vertical-align: middle;
        color: #434343;
    }
}
</style>
